import React from 'react';

const Footer = () => (
  <footer className="text-center text-xs text-gray-500 dark:text-gray-400 py-6">
    © 2025 직관가자. All rights reserved.
    <br />
    Created and maintained by Sumin Lee.
    <br />
    Weather data © Korea Meteorological Administration · Open-Meteo.
    <br />
    <a
      href="mailto:jikgwangaza@gmail.com?subject=Bug%20Report"
      className="underline hover:text-blue-600"
    >
      오류 제보하기
    </a>
  </footer>
);

export default Footer;
